var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "nl", class: "nl--" + _vm.align }, [
    _c("div", { staticClass: "nl__inner" }, [
      _vm.heading
        ? _c("h2", { staticClass: "nl__h" }, [_vm._v(_vm._s(_vm.heading))])
        : _vm._e(),
      _vm._v(" "),
      _vm.text
        ? _c("p", { staticClass: "nl__p" }, [_vm._v(_vm._s(_vm.text))])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "nl__form",
        domProps: { innerHTML: _vm._s(_vm.embedTag) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }